import serverCall from "../../serverCall";

const create4DParallaxImage = async (data) => {
    const response = await serverCall.post(
        `/images/admin/fourd-image`, data
    );
    return response;
};

const newCreate4DParallaxImage = async (data) => {
    const response = await serverCall.post(
        `/images/admin/v2/fourd-image`, data
    );
    return response;
};

const GetAll4DParallaxImages = async (id) => {
    const response = await serverCall.get(`/category/admin/all-category`);
    return response;
};

const Delete4DParallax = async (id) => {
    const response = await serverCall.delete(`/category/admin/${id}`);
    return response;
};

const Parallax4DImageService = {
    create4DParallaxImage,
    GetAll4DParallaxImages,
    Delete4DParallax,
    newCreate4DParallaxImage,
};

export default Parallax4DImageService;
